import styled from 'styled-components';

const Label = styled.label`
  &:hover {
    cursor: pointer;
  }
`;

export default Label;
